import React from 'react';
import './ProductSettings.scss';
import {simpleNotification} from "../../utils/notifications";

class ProductSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Product Type Settings
      productTypeInput: '',
      productTypes: [],

      // Price Range Settings
      priceMinInput: '',
      priceMaxInput: '',
      priceRanges: [],

      // Commission Range Settings
      commissionMinInput: '',
      commissionMaxInput: '',
      commissionRanges: [],

      // Wallet Address Settings
      walletAddressInput: '',
      walletAddress: '',

      // Platform Guide Settings
      platformSelect: '',
      guideLink: '',
      platformGuides: [],

      draggedItem: null,
    };
  }

  componentDidMount() {
    const { token } = this.props.auth;
    this.props.getAllSaleProductProperties(token);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.user.saleProductProperties.isLoading === true && this.props.user.saleProductProperties.isLoading === false) {
      if (this.props.user.saleProductProperties.errors.hasError) {
      }else{
        //console.log(this.props.user.saleProductProperties);
        this.setSettingStates(this.props.user.saleProductProperties?.data)
      }
    }
    if (prevProps.admin.saleProductSetting.isLoading === true && this.props.admin.saleProductSetting.isLoading === false) {
      if (this.props.admin.saleProductSetting.errors.hasError) {
        simpleNotification({
          level: "error",
          title: this.props.admin.saleProductSetting.errors.message,
          message: "Product setting failed!",
        });
      }else{
        // console.log(this.props.admin.saleProductSetting);
        this.setSettingStates(this.props.admin.saleProductSetting?.data)
        this.setState({productTypeInput: '',commissionMinInput: '', commissionMaxInput: '', priceMinInput: '', priceMaxInput: '', walletAddressInput: '',guideLink: ''})
      }
    }
  }

  setSettingStates = (saleProductProperties) =>{
    this.setState({productTypes:saleProductProperties.types||[]});
    this.setState({priceRanges:saleProductProperties.priceSearchs||[]});
    this.setState({commissionRanges:saleProductProperties.commissionSearchs||[]});
    this.setState({walletAddress:saleProductProperties.walletAddress||""});
    this.setState({platformGuides:saleProductProperties.platformGuides||[]});
  }

  // Product Type Methods
  handleAddProductType = () => {
    const { productTypeInput,productTypes} = this.state;
    if (productTypeInput.trim() && !productTypes.includes(productTypeInput.trim())) {
      const { token } = this.props.auth;
      this.props.updateSaleProductSetting(JSON.stringify({types:[...productTypes, productTypeInput.trim()]}),token);
      // this.setState({
      //   productTypes: [...productTypes, productTypeInput.trim()],
      //   productTypeInput: '',
      // });
    }
  }

  handleRemoveProductType = (type) => {
    const { productTypes} = this.state;
    if (type.trim() && productTypes.includes(type.trim())) {
      const { token } = this.props.auth;
      this.props.updateSaleProductSetting(JSON.stringify({types:productTypes.filter(item=>item !==type.trim())}),token);
    }
  }

  handleDragStart = (index, type) => {
    this.setState({ draggedItem: { index, type } });
  }

  handleDragOver = (e) => {
    e.preventDefault();
  }

  handleDrop = (dropIndex, type) => {
    const { draggedItem } = this.state;
    if (!draggedItem || draggedItem.type !== type) return;

    const items = [...this.state[type]];
    const [draggedItemContent] = items.splice(draggedItem.index, 1);
    items.splice(dropIndex, 0, draggedItemContent);

    this.setState({
      [type]: items,
      draggedItem: null,
    });
  }

  // Price Range Methods
  handleAddPriceRange = () => {
    const { priceMinInput, priceMaxInput, priceRanges } = this.state;
    const min = parseFloat(priceMinInput);
    const max = parseFloat(priceMaxInput);
    if(!isNaN(min)&&!isNaN(max)&&min>max){
      return;
    }

    if (!isNaN(min) || !isNaN(max)) {
      if((!isNaN(min)&&priceRanges.findIndex(p=>p.min===min)>-1)||(!isNaN(max)&&priceRanges.findIndex(p=>p.max===max)>-1)){
        return;
      }
      const priceRange = {...(!isNaN(min) && { min }),...(!isNaN(max) && { max })};
      const { token } = this.props.auth;
      this.props.updateSaleProductSetting(JSON.stringify({priceSearchs:[...priceRanges, priceRange]}),token);
      // const label = priceMaxInput ? `${min}–${max}` : `>${min}`;
      // const newRange = {
      //   id: Date.now(),
      //   label,
      //   min,
      //   max: priceMaxInput ? max : null,
      // };
      //
      // this.setState({
      //   priceRanges: [...priceRanges, newRange],
      //   priceMinInput: '',
      //   priceMaxInput: '',
      // });
    }
  }

  handleRemovePriceRange = (id) => {
    const {priceRanges}=this.state;
    if (id&&id.trim() && priceRanges.findIndex(p=>p.title === id.trim())>-1) {
      const { token } = this.props.auth;
      this.props.updateSaleProductSetting(JSON.stringify({priceSearchs:priceRanges.filter(item=>item.title !==id.trim())}),token);
    }
    // this.setState({
    //   priceRanges: this.state.priceRanges.filter(r => r.id !== id),
    // });
  }

  // Commission Range Methods
  handleAddCommissionRange = () => {
    const { commissionMinInput, commissionMaxInput, commissionRanges } = this.state;
    const min = parseFloat(commissionMinInput);
    const max = parseFloat(commissionMaxInput);
    if(!isNaN(min)&&!isNaN(max)&&min>max){
      return;
    }
    if (!isNaN(min) || !isNaN(max)) {
      if((!isNaN(min)&&commissionRanges.findIndex(p=>p.min===min)>-1)||(!isNaN(max)&&commissionRanges.findIndex(p=>p.max===max)>-1)){
        return;
      }
      const commissionRange = {...(!isNaN(min) && { min }),...(!isNaN(max) && { max })};
      const { token } = this.props.auth;
      this.props.updateSaleProductSetting(JSON.stringify({commissionSearchs:[...commissionRanges, commissionRange]}),token);
    }
  }

  handleRemoveCommissionRange = (id) => {
    const {commissionRanges}=this.state;
    if (id&&id.trim() && commissionRanges.findIndex(p=>p.title === id.trim())>-1) {
      const { token } = this.props.auth;
      this.props.updateSaleProductSetting(JSON.stringify({commissionSearchs:commissionRanges.filter(item=>item.title !==id.trim())}),token);
    }
    // this.setState({
    //   commissionRanges: this.state.commissionRanges.filter(r => r.id !== id),
    // });
  }

  // Wallet Address Methods
  handleSetWalletAddress = () => {
    const { walletAddressInput } = this.state;
    if (walletAddressInput.trim()) {
      const { token } = this.props.auth;
      this.props.updateSaleProductSetting(JSON.stringify({walletAddress:walletAddressInput.trim()}),token);
      // this.setState({
      //   walletAddress: walletAddressInput.trim(),
      //   walletAddressInput: '',
      // });
    }
  }

  handleRemoveWalletAddress = () => {
    const { token } = this.props.auth;
    this.props.updateSaleProductSetting(JSON.stringify({walletAddress:""}),token);
    // this.setState({ walletAddress: '' });
  }

  // Platform Guide Methods
  handleAddPlatformGuide = () => {
    const { platformSelect, guideLink, platformGuides } = this.state;
    if (platformSelect && guideLink.trim()&&platformGuides.findIndex(p=>p.platform===platformSelect)<0) {
      const { token } = this.props.auth;
      const platformGuide = {platform:platformSelect,link:guideLink.trim()};
      this.props.updateSaleProductSetting(JSON.stringify({platformGuides:[...platformGuides, platformGuide]}),token);

      // this.setState({
      //   platformGuides: [...platformGuides, newGuide],
      //   platformSelect: '',
      //   guideLink: '',
      // });
    }
  }

  handleRemovePlatformGuide = (id) => {
    const {platformGuides}=this.state;
    if (id&&id.trim() && platformGuides.findIndex(p=>p.platform === id.trim())>-1) {
      const { token } = this.props.auth;
      this.props.updateSaleProductSetting(JSON.stringify({platformGuides:platformGuides.filter(item=>item.platform !==id.trim())}),token);
    }
    // this.setState({
    //   platformGuides: this.state.platformGuides.filter(g => g.id !== id),
    // });
  }

  getProductTypes = () =>{
    const {data:setting} = this.props.admin.setting;
    return setting?.values;
  }

  render() {
    const {
      productTypeInput,
      productTypes,
      priceMinInput,
      priceMaxInput,
      priceRanges,
      commissionMinInput,
      commissionMaxInput,
      commissionRanges,
      walletAddressInput,
      walletAddress,
      platformSelect,
      guideLink,
      platformGuides,
    } = this.state;
    return (
      <div className="product-settings">
        <div className="page-header">
          <h2>Setting</h2>
          <p>Configure product-related system settings</p>
        </div>

        {/* 1. Product Type Settings */}
        <div className="settings-section">
          <h3 className="section-title">Product Type Settings</h3>

          <div className="input-group">
            <input
              type="text"
              className="input-field"
              placeholder="Enter product type"
              value={productTypeInput}
              onChange={(e) => this.setState({ productTypeInput: e.target.value })}
              onKeyPress={(e) => e.key === 'Enter' && this.handleAddProductType()}
            />
            <button className="add-btn" onClick={this.handleAddProductType}>
              <i className="fa fa-plus" /> Add
            </button>
          </div>

          <div className="tags-container">
            {productTypes?.map((type, index) => (
              <div
                key={index}
                className="tag"
                draggable
                onDragStart={() => this.handleDragStart(index, 'productTypes')}
                onDragOver={this.handleDragOver}
                onDrop={() => this.handleDrop(index, 'productTypes')}
              >
                <span>{type}</span>
                <i className="fa fa-times" onClick={() => this.handleRemoveProductType(type)} />
              </div>
            ))}
          </div>

          <p className="helper-text">
            <i className="fa fa-info-circle" /> Tip: Drag tags to change the display order
          </p>
        </div>

        {/* 2. Price Search Range Settings */}
        <div className="settings-section">
          <h3 className="section-title">Price Search Range Settings</h3>

          <div className="input-group range-inputs">
            <input
              type="number"
              className="input-field"
              placeholder="Minimum Value"
              value={priceMinInput}
              onChange={(e) => this.setState({ priceMinInput: e.target.value })}
            />
            <span className="separator">–</span>
            <input
              type="number"
              className="input-field"
              placeholder="Maximum Value"
              value={priceMaxInput}
              onChange={(e) => this.setState({ priceMaxInput: e.target.value })}
            />
            <button className="add-btn" onClick={this.handleAddPriceRange}>
              <i className="fa fa-plus" /> Add
            </button>
          </div>

          <div className="tags-container">
            {priceRanges?.map((range, index) => (
              <div
                key={range.title}
                className="tag"
                draggable
                onDragStart={() => this.handleDragStart(index, 'priceRanges')}
                onDragOver={this.handleDragOver}
                onDrop={() => this.handleDrop(index, 'priceRanges')}
              >
                <span>{range.title}</span>
                <i className="fa fa-times" onClick={() => this.handleRemovePriceRange(range.title)} />
              </div>
            ))}
          </div>

          <p className="helper-text">
            <i className="fa fa-info-circle" /> Tip: Drag tags to change the display order
          </p>
        </div>

        {/* 3. Commission Search Range Settings */}
        <div className="settings-section">
          <h3 className="section-title">Commission Search Range Settings</h3>

          <div className="input-group range-inputs">
            <input
              type="number"
              className="input-field"
              placeholder="Minimum Value (%)"
              value={commissionMinInput}
              onChange={(e) => this.setState({ commissionMinInput: e.target.value })}
            />
            <span className="separator">–</span>
            <input
              type="number"
              className="input-field"
              placeholder="Maximum Value (%)"
              value={commissionMaxInput}
              onChange={(e) => this.setState({ commissionMaxInput: e.target.value })}
            />
            <button className="add-btn" onClick={this.handleAddCommissionRange}>
              <i className="fa fa-plus" /> Add
            </button>
          </div>

          <div className="tags-container">
            {commissionRanges.map((range, index) => (
              <div
                key={range.title}
                className="tag"
                draggable
                onDragStart={() => this.handleDragStart(index, 'commissionRanges')}
                onDragOver={this.handleDragOver}
                onDrop={() => this.handleDrop(index, 'commissionRanges')}
              >
                <span>{range.title}</span>
                <i className="fa fa-times" onClick={() => this.handleRemoveCommissionRange(range.title)} />
              </div>
            ))}
          </div>

          <p className="helper-text">
            <i className="fa fa-info-circle" /> Tip: Drag tags to change the display order
          </p>
        </div>

        {/* 4. Payment Digital Wallet Address Settings */}
        <div className="settings-section">
          <h3 className="section-title">Payment Digital Wallet Address Settings</h3>

          <div className="input-group">
            <input
              type="text"
              className="input-field"
              placeholder="Enter digital wallet address"
              value={walletAddressInput}
              onChange={(e) => this.setState({ walletAddressInput: e.target.value })}
              onKeyPress={(e) => e.key === 'Enter' && this.handleSetWalletAddress()}
            />
            <button className="add-btn" onClick={this.handleSetWalletAddress}>
              Set
            </button>
          </div>

          {walletAddress && (
            <div className="tags-container">
              <div className="tag wallet-tag">
                <span>{walletAddress}</span>
                <i className="fa fa-times" onClick={this.handleRemoveWalletAddress} />
              </div>
            </div>
          )}
        </div>

        {/* 5. Game Platform & Guide Link Settings */}
        <div className="settings-section">
          <h3 className="section-title">Game Platform & Guide Link Settings</h3>

          <div className="input-group platform-inputs">
            {/*<select*/}
            {/*  value={platformSelect}*/}
            {/*  onChange={(e) => this.setState({ platformSelect: e.target.value })}*/}
            {/*>*/}
            {/*  <option value="">Select Platform</option>*/}
            {/*  <option value="Steam">Steam</option>*/}
            {/*  <option value="Epic Games">Epic Games</option>*/}
            {/*  <option value="GOG">GOG</option>*/}
            {/*  <option value="Origin">Origin</option>*/}
            {/*  <option value="Uplay">Uplay</option>*/}
            {/*  <option value="Battle.net">Battle.net</option>*/}
            {/*</select>*/}
            <input
                type="text"
                className="input-field"
                placeholder="Enter Platform Name"
                value={platformSelect}
                onChange={(e) => this.setState({ platformSelect: e.target.value })}
                style={{flex:0.5}}
            />
            <input
              type="text"
              className="input-field"
              placeholder="Enter guide link"
              value={guideLink}
              onChange={(e) => this.setState({ guideLink: e.target.value })}
              onKeyPress={(e) => e.key === 'Enter' && this.handleAddPlatformGuide()}
            />
            <button className="add-btn" onClick={this.handleAddPlatformGuide}>
              <i className="fa fa-plus" /> Add
            </button>
          </div>

          <div className="platform-table">
            {platformGuides&&platformGuides.length>0&&<table>
              <thead>
                <tr>
                  <th>Platform Name</th>
                  <th>Guide Link</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {platformGuides.map((guide) => (
                  <tr key={guide.platform}>
                    <td>{guide.platform}</td>
                    <td className="link-cell">{guide.link}</td>
                    <td className="action-cell">
                      <button
                        className="remove-btn"
                        onClick={() => this.handleRemovePlatformGuide(guide.platform)}
                      >
                        <i className="fa fa-trash" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>}
          </div>
        </div>
      </div>
    );
  }
}

export default ProductSettings;
